import { getDefaultRichTextEditorData } from 'utils';
import { DEFAULT_GATE_TITLE, DEFAULT_GATE_SUBTITLE } from 'shared/constants';
import { MAESTRO_WHITE } from 'style/constants';
import { injectT } from 'hooks/use-translation';

export const getTitleData = injectT(
  (t) => (title: string, titleRawData: string, contentTextColor: string) => {
    // Styled Data
    if (titleRawData) {
      return titleRawData;
    }
    // Default Data
    return getDefaultRichTextEditorData({
      text: title || '',
      color:
        title === DEFAULT_GATE_TITLE(t) ? MAESTRO_WHITE : contentTextColor,
      fontSize: 30,
    });
  },
);

export const getSubtitleData = injectT(
  (t) => (subtitle: string, subtitleRawData: string, contentTextColor: string) => {
    // Styled Data
    if (subtitleRawData) {
      return subtitleRawData;
    }
    // Default Data
    return getDefaultRichTextEditorData({
      text: subtitle || '',
      color:
        subtitle === DEFAULT_GATE_SUBTITLE(t) ? MAESTRO_WHITE :
        contentTextColor,
      fontSize: 14,
    });
  },
);
